import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type Attachment = {
  __typename?: 'Attachment';
  downloadUrl: Scalars['String'];
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export enum Language {
  En = 'en',
  Fi = 'fi',
  Sv = 'sv'
}

export type Mutation = {
  __typename?: 'Mutation';
  startTrial: StartTrialResult;
};


export type MutationStartTrialArgs = {
  input: StartTrialInput;
};

export type Query = {
  __typename?: 'Query';
  attachment: Attachment;
  dummy: Scalars['String'];
};


export type QueryAttachmentArgs = {
  attachmentId: Scalars['String'];
  downloadFileName: Scalars['String'];
  language: Language;
};

export type StartTrialInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  language: Language;
  lastName: Scalars['String'];
  organization?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type StartTrialResult = {
  __typename?: 'StartTrialResult';
  success?: Maybe<Scalars['Boolean']>;
};

export type GetAttachmentQueryVariables = Exact<{
  language: Language;
  attachmentId: Scalars['String'];
  downloadFileName: Scalars['String'];
}>;


export type GetAttachmentQuery = { __typename?: 'Query', attachment: { __typename?: 'Attachment', downloadUrl: string } };

export type StartTrialMutationVariables = Exact<{
  input: StartTrialInput;
}>;


export type StartTrialMutation = { __typename?: 'Mutation', startTrial: { __typename?: 'StartTrialResult', success?: boolean | null } };


export const GetAttachmentDocument = gql`
    query GetAttachment($language: Language!, $attachmentId: String!, $downloadFileName: String!) {
  attachment(
    language: $language
    attachmentId: $attachmentId
    downloadFileName: $downloadFileName
  ) {
    downloadUrl
  }
}
    `;

/**
 * __useGetAttachmentQuery__
 *
 * To run a query within a React component, call `useGetAttachmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttachmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttachmentQuery({
 *   variables: {
 *      language: // value for 'language'
 *      attachmentId: // value for 'attachmentId'
 *      downloadFileName: // value for 'downloadFileName'
 *   },
 * });
 */
export function useGetAttachmentQuery(baseOptions: Apollo.QueryHookOptions<GetAttachmentQuery, GetAttachmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttachmentQuery, GetAttachmentQueryVariables>(GetAttachmentDocument, options);
      }
export function useGetAttachmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttachmentQuery, GetAttachmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttachmentQuery, GetAttachmentQueryVariables>(GetAttachmentDocument, options);
        }
export type GetAttachmentQueryHookResult = ReturnType<typeof useGetAttachmentQuery>;
export type GetAttachmentLazyQueryHookResult = ReturnType<typeof useGetAttachmentLazyQuery>;
export type GetAttachmentQueryResult = Apollo.QueryResult<GetAttachmentQuery, GetAttachmentQueryVariables>;
export const StartTrialDocument = gql`
    mutation StartTrial($input: StartTrialInput!) {
  startTrial(input: $input) {
    success
  }
}
    `;
export type StartTrialMutationFn = Apollo.MutationFunction<StartTrialMutation, StartTrialMutationVariables>;

/**
 * __useStartTrialMutation__
 *
 * To run a mutation, you first call `useStartTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startTrialMutation, { data, loading, error }] = useStartTrialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartTrialMutation(baseOptions?: Apollo.MutationHookOptions<StartTrialMutation, StartTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartTrialMutation, StartTrialMutationVariables>(StartTrialDocument, options);
      }
export type StartTrialMutationHookResult = ReturnType<typeof useStartTrialMutation>;
export type StartTrialMutationResult = Apollo.MutationResult<StartTrialMutation>;
export type StartTrialMutationOptions = Apollo.BaseMutationOptions<StartTrialMutation, StartTrialMutationVariables>;